import _ from 'lodash';
import {
  GET_STATS_SUCCESS,
  SET_RANGE,
  GET_DASHBOARD_CUSTOMERS_SUCCESS,
  GET_DASHBOARD_ORDERS_SUCCESS,
} from '../actions/types';

export const RANGES = {
  TODAY: { value: 1, text: 'Today' },
  WEEK: { value: 7, text: 'Week' },
  MONTH: { value: 30, text: 'Month' },
  YEAR: { value: 365, text: 'Year' },
  ALL: { value: 0, text: 'All' },
};

const defaultState = {
  range: RANGES.WEEK,
  stats: [],
  customers: [],
  orders: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_STATS_SUCCESS: return { ...state, stats: action.payload };
    case SET_RANGE: return { ...state, range: _.find(RANGES, r => r.value === action.payload) };
    case GET_DASHBOARD_CUSTOMERS_SUCCESS: return { ...state, customers: action.payload };
    case GET_DASHBOARD_ORDERS_SUCCESS: return { ...state, orders: action.payload };
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard.reducer.js